import type { CharacterId, GiantId } from '../../../domain/ids/ids';
import { getSecondChanceMinigameId } from '../../../domain';
import { ClaudiPairsGame } from './games/ClaudiPairsGame';
import { EddyLuckyShotGame } from './games/EddyLuckyShotGame';
import { RockRotatePuzzleGame } from './games/RockRotatePuzzleGame';
import { TuchiMelodyGame } from './games/TuchiMelodyGame';
import { UfoDecipherGame } from './games/UfoDecipherGame';
import { VallDropBoxGame } from './games/VallDropBoxGame';

export type SecondChanceMinigameRouterProps = {
  characterId: CharacterId;
  giantId: GiantId;
  onWin: () => void;
  onLose: () => void;
  onTimerChange?: (secondsLeft: number | null) => void;
};

export function SecondChanceMinigameRouter({
  characterId,
  giantId,
  onWin,
  onLose,
  onTimerChange,
}: SecondChanceMinigameRouterProps) {
  const minigameId = getSecondChanceMinigameId(characterId);

  switch (minigameId) {
    case 'eddy_lucky_shot':
      return (
        <EddyLuckyShotGame
          onWin={onWin}
          onLose={onLose}
          onTimerChange={onTimerChange}
        />
      );
    case 'claudi_find_pairs':
      return (
        <ClaudiPairsGame
          giantId={giantId}
          onWin={onWin}
          onLose={onLose}
          onTimerChange={onTimerChange}
        />
      );
    case 'tuchi_melody':
      return (
        <TuchiMelodyGame
          onWin={onWin}
          onLose={onLose}
          onTimerChange={onTimerChange}
        />
      );
    case 'ufo_decipher_words':
      return (
        <UfoDecipherGame
          onWin={onWin}
          onLose={onLose}
          onTimerChange={onTimerChange}
        />
      );
    case 'vall_drop_box':
      return (
        <VallDropBoxGame
          onWin={onWin}
          onLose={onLose}
          onTimerChange={onTimerChange}
        />
      );
    case 'rock_rotate_puzzle':
      return (
        <RockRotatePuzzleGame
          onWin={onWin}
          onLose={onLose}
          onTimerChange={onTimerChange}
        />
      );
    default: {
      const _exhaustive: never = minigameId;
      return _exhaustive;
    }
  }
}

export function getSecondChanceMinigameTitle(characterId: CharacterId): string {
  const minigameId = getSecondChanceMinigameId(characterId);
  switch (minigameId) {
    case 'eddy_lucky_shot':
      return 'Сними удачный кадр';
    case 'claudi_find_pairs':
      return 'Запомни пары';
    case 'tuchi_melody':
      return 'Собери мелодию';
    case 'ufo_decipher_words':
      return 'Переведи слова';
    case 'vall_drop_box':
      return 'Положи посылку';
    case 'rock_rotate_puzzle':
      return 'Почини трубы';
    default: {
      const _exhaustive: never = minigameId;
      return _exhaustive;
    }
  }
}
